import { AddInError } from '../addInError';
import { logError } from './logger';
import { maskEmail } from './maskEmail';

type OfficeErrorContext = {
  operation: string;
  isSharedMailbox?: boolean;
  mailboxEmail?: string;
  itemId?: string;
  [key: string]: any;
};

export const handleOfficeError = (
  officeError: Office.Error,
  context: OfficeErrorContext,
): AddInError => {
  const { operation, isSharedMailbox, mailboxEmail, itemId, ...additionalContext } = context;

  const details = {
    code: officeError.code,
    message: officeError.message,
    name: officeError.name,
    isSharedMailbox,
    mailboxEmail: maskEmail(mailboxEmail),
    itemId,
    ...additionalContext,
  };

  // Log error details for debugging
  logError(`${operation} failed`, details);

  return new AddInError(`${operation} failed (code: ${officeError.code})`, details);
};
